import styled from 'styled-components'
import { Body, breakpoints, colors, Dialog, Spacer } from '@spritz-finance/ui'
import { Column } from '../../../../../components/Layout/Column'
import { Row } from '../../../../../components/Layout/Row'

const Amount = styled.div`
    font-weight: bold;
    font-size: 16px;
`

const AmountsTable = styled.table`
    width: 100%;
    border: 1px solid var(--surface-3, ${colors.ltGrey});
    border-collapse: collapse;

    tr {
    }

    td {
        padding: 0;
        border: 1px solid var(--surface-3, ${colors.ltGrey});
    }
`

const Cell = styled.td`
    width: 156px;
    height: 56px;
    padding: 8px;
    text-align: center;
    font-size: 12px;
`

const RowHeader = styled(Cell)`
    background-color: var(--surface-4, ${colors.silverGray});
    color: var(--text-secondary, ${colors.charcoal});
`

const PricingDialogContentWrapper = styled(Dialog.Content)`
    padding: 16px 6px;
    width: 700px;
    max-width: calc(100% - 20px);

    ${breakpoints.xsmall} {
        width: calc(100% - 20px);
        padding: 16px 0px;

        td:first-child {
            display: none;
        }

        td {
            height: 80px;
        }
    }
`

export const PricingDialogContent = () => {
    return (
        <PricingDialogContentWrapper>
            <Column align="center">
                <Spacer height={32} />
                <Body.Bold>Fees</Body.Bold>
                <Spacer height={32} />
                <Body.Med>
                    Spritz fees are calculated based on your total transactions in a one-month
                    period. The more you pay toward your bills, the less you pay in fees!
                </Body.Med>
                <Spacer height={32} />

                <AmountsTable>
                    <tr>
                        <RowHeader>TRANSACTION VOLUME*</RowHeader>
                        <Cell>
                            <Amount>&lt; $100</Amount>
                            MONTHLY
                        </Cell>
                        <Cell>
                            <Amount>$101 - $1,000</Amount>
                            MONTHLY
                        </Cell>
                        <Cell>
                            <Amount>$1,000 - $5,000</Amount>
                            MONTHLY
                        </Cell>
                        <Cell>
                            <Amount>$5,000+</Amount>
                            MONTHLY
                        </Cell>
                    </tr>
                    <tr>
                        <RowHeader>TRANSACTION FEE</RowHeader>
                        <Cell>
                            <Body.Med size={16}>Free</Body.Med>
                        </Cell>
                        <Cell>
                            <Body.Med size={16}>1.95%</Body.Med>
                        </Cell>
                        <Cell>
                            <Body.Med size={16}>1.75%</Body.Med>
                        </Cell>
                        <Cell>
                            <Body.Med size={16}>1.5%</Body.Med>
                        </Cell>
                    </tr>
                </AmountsTable>
                <Spacer height={8} />
                <Row align="left" style={{ width: '100%' }}>
                    <Body.Med size={12}>
                        *Total volume of both bill pay transactions and ACH transfers.
                    </Body.Med>
                </Row>

                <Spacer height={32} />
                <Body.Med size={16}>
                    For example: This month, if you pay a $200 bill, you'll have zero fees on the
                    first $100, and a fee of 1.95% on the remaining $100. If you then pay a $1,000
                    bill in the same month, you’ll have a fee of 1.95% on $900 and a fee of 1.75% on
                    $100.
                </Body.Med>
            </Column>
        </PricingDialogContentWrapper>
    )
}

export const PricingDialog: React.VFC<{ open?: boolean; onClose: () => void }> = ({
    open,
    onClose,
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <PricingDialogContent />
        </Dialog>
    )
}
